import { client, handleRequestBody } from "./client.ts";

export type OnboardingProfileInput =
	| "construction-company"
	| "independent-pro"
	| "self-build"
	| "renovation";

export type OnboardingModeInput = "site-projects" | "single-project";

export type OnboardingSiteStatusInput = "active" | "paused" | "archived";

export type OnboardingInviteRoleInput =
	| "engineer"
	| "almoxarife"
	| "funcionario"
	| "cliente";

export interface OnboardingAddressInput {
	street: string;
	number: string;
	complement?: string;
	neighborhood: string;
	city: string;
	state: string;
	zipcode: string;
	lat?: number;
	lng?: number;
}

export interface OnboardingSiteInput {
	name: string;
	address: OnboardingAddressInput;
	area: string;
	status: OnboardingSiteStatusInput;
}

export interface OnboardingConstructionInput {
	name: string;
	type: string;
	color: string;
	address: OnboardingAddressInput;
	start_date: string | null;
	end_date: string | null;
}

export interface OnboardingInviteInput {
	email: string;
	role: OnboardingInviteRoleInput;
}

export interface CompleteOnboardingRequest {
	profile: OnboardingProfileInput;
	company_name: string | null;
	mode: OnboardingModeInput;
	site: OnboardingSiteInput | null;
	construction: OnboardingConstructionInput | null;
	invites: OnboardingInviteInput[];
}

export interface CompleteOnboardingResponse {
	account_id: string;
	worksite_id: string;
	construction_id?: string;
	invites: { id: string; email: string; role: string }[];
}

export function completeOnboarding(
	req: CompleteOnboardingRequest,
): Promise<CompleteOnboardingResponse> {
	return handleRequestBody(() =>
		client.post<CompleteOnboardingResponse>("/onboarding", req),
	);
}

export interface SignupRequest {
	name: string;
	email: string;
	password: string;
	invite_token: string;
}

export function signup(req: SignupRequest): Promise<void> {
	return handleRequestBody(() => client.post("/onboarding/signup", req));
}

export function resendVerification(email: string): Promise<void> {
	return handleRequestBody(() =>
		client.post("/onboarding/resend-verification", { email }),
	);
}

export interface VerifyEmailResponse {
	jwt: string;
	accounts: { id: string; name: string }[];
	user: { name: string; email: string };
}

export function verifyEmail(token: string): Promise<VerifyEmailResponse> {
	return handleRequestBody(() =>
		client.post<VerifyEmailResponse>("/onboarding/verify-email", { token }),
	);
}
